import { render, staticRenderFns } from "./EventRevenue.vue?vue&type=template&id=b51be0fc&"
import script from "./EventRevenue.vue?vue&type=script&lang=js&"
export * from "./EventRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports